import { Map } from 'immutable';

import { setDrawingType } from './StructureFilterConstants';

export const initialState = Map({});

// eslint-disable-next-line default-param-last
export function structureFilterReducer(state = initialState, action) {
  if (action.type === setDrawingType) {
    const { key, data } = action.payload;

    return state.set(key, data);
  }
  return state;
}
